<template>
  <div>
    <div class="logo">
      <div class="index_logo">
        <div class="logo_left">
<!--          <img :src="info.logo"/>-->
          <div class="name">广西建设教育服务共享课件超市</div>
        </div>
        <div class="logo_right">
          <div class="name" @click="toggleHome" v-if="path!=='/index'">首页</div>
          <div class="name" @click="toggleBook" :class="[path=='/newCourse/list'?'active':'']">选课专区</div>
          <div class="learning" @mouseover="changeStyle" @mouseout="restStyle">
            手机学习
            <div class="learning_wx animate__animated animate__fadeInRight" v-show="wx_code">
              <div>关注微信小程序</div>
              <div>掌上随时随地学习</div>
              <img src="https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20220421/gh_24834f70db66_1280 (1).jpg"/>
            </div>
          </div>
          <div class="logo_right_dl">
            <div class="login_name">
              <template v-if="user!=null">
                <div class="personal" @click="toggleMy">个人中心</div>
                <div class="personal_hy">欢迎您，{{ user.realName }}</div>
                <div class="personal_out" @click="toggleOut">退出登录</div>
              </template>
              <template v-else>
                <img @click="toggleLogin" src="@/assets/img/login.png"/>
                <div @click="toggleLogin" class="no_login">登录</div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
            z-index="999"
            :visible.sync="dialogVisible_show"
            width="20%"
            :modal="true"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :show-close="false"
    >
      <div class="login-main">
        <div class="login-title">验证码登陆</div>
        <el-row :gutter="20">
          <el-col :span="20">
            <el-input v-model="temp.identityCard" placeholder="仅限中国大陆用户"></el-input>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-input v-model="temp.identityCard" placeholder="输入验证码"></el-input>
          </el-col>
          <el-col :span="12">
            <el-button type="text" class="el-link">获取验证码</el-button>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <JcRange status="ruleForm.status" :successFun="onMpanelSuccess" :errorFun="onMpanelError"></JcRange>
          </el-col>
        </el-row>


        <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible_show = false">取 消</el-button>
                <el-button type="primary" @click="handleLogin">登录</el-button>
            </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import {GetUserInfoByidentityCard} from '@/api/login'
    import {login} from '@/api/temporary'
    import {GetIdByInfo} from '@/api/cooperation'

    import JcRange from "@/components/verification/JcRange.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "Index",
        props: {
            title: String,
        },
        components: {
            JcRange
        },
        computed: {
            ...mapGetters(['userinfo', 'inst_id'])
        },
        watch: {
            $route(to, from) {
                this.path = this.$route.path
            }
        },

        data() {
            var checkStatus = (rule, value, callback) => {
                console.log(value);
                if (!value) {
                    return callback(new Error("请拖动滑块完成验证"));
                } else {
                    callback();
                }
            };
            return {
                path: '/',
                status: [{validator: checkStatus, trigger: "change"}],
                is_login: false,
                dialogVisible_show: false,
                wx_code: false,
                temp: {
                    identityCard: "",
                },
                loginForm: {
                    username: '',
                    identitycard: '',
                },
                apply_id: 0,
                info: {},
                user: {}
            }
        },
        created() {
            this.user = JSON.parse(this.userinfo)
            this.getinfo()
        },
        methods: {
            toggleOut() {
                this.$confirm('退出登录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$store.dispatch('user/SETUserInfo', null);//当页面刷新时把缓存数据赋值给vuex
                    localStorage.setItem('userinfo', null)
                    localStorage.setItem('apply_id', null)
                    this.$router.push({path: '/login'})
                    window.location.reload();
                    this.$message({
                        type: 'success',
                        message: '已退出登录!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消退出登录'
                    });
                });
            },
            onMpanelSuccess(e) {
                console.log(e, '成功')
            },
            onMpanelError() {

            },
            getinfo() {
                let inst_id = this.inst_id
                console.log(this.inst_id, "顶部")
                GetIdByInfo(inst_id).then(res => {
                    this.info = res.data
                })
            },
            toggledDownload() {
                this.path = '/download/index'
                this.$router.push({
                    path: '/download/index'
                })
            },
            toggleQuery() {
                this.path = '/index/query'
                this.$router.push({
                    path: '/index/query'
                })
            },

            toggleQuestion(path) {
                this.path = path
                this.$router.push({
                    path
                })
            },


            toggleMy() {
                this.path = '/my'
                this.$router.push({
                    path: '/my'
                })
            },
            toggleBook() {
                this.path = '/newCourse/list'
                this.$router.push({
                    path: '/newCourse/list'
                })
            },
            toggleHome() {
                this.path = '/index'
                this.$router.push({
                    path: '/index'
                })
            },
            toggleDynamic() {
                this.path = '/dynamic/list'
                this.$router.push({
                    path: '/dynamic/list'
                })
            },
            //考试报名列表
            toggleApplylist() {
                this.path = '/apply/list'
                this.$router.push({
                    path: '/apply/list'
                })
            },
            //点击登录
            toggleLogin() {
                this.$router.push('/login')
            },
            handleLogin() {
                let that = this
                GetUserInfoByidentityCard(that.temp).then(res => {
                    if (res.code !== 20000) {
                        that.$notify.error({
                            title: '错误',
                            message: res.msg
                        });
                    } else {
                        that.$notify({
                            title: '成功',
                            message: res.msg,
                            type: 'success'
                        });
                        that.userinfo = res.data
                        localStorage.setItem('userinfo', JSON.stringify(res.data))
                        that.is_login = true
                        localStorage.setItem('is_login', true)
                        localStorage.setItem('user_id', res.data.user_id)
                        that.dialogVisible_show = false
                        this.loginForm.identitycard = res.data.identityCard
                        login(this.loginForm).then(res => {
                            this.apply_id = res.data
                            localStorage.setItem('apply_id', res.data)
                        })
                    }
                })
            },
            //移入
            changeStyle() {
                this.wx_code = true;
            },
            //移出
            restStyle() {
                this.wx_code = false;
            }
        }
    }
</script>

<style lang="scss" scoped>
  .login-main {
    font: 14px/1.5 "PingFang SC", "微软雅黑", "Microsoft YaHei", Helvetica, "Helvetica Neue", Tahoma, Arial, sans-serif;
    padding: 20px;
    padding-top: 5px;

    .login-title {
      display: flex;
      flex-direction: row;
      justify-content: center;
      //margin-bottom: 30px;
      color: #3c89e2;
      height: 40px;
      line-height: 40px;
      font-size: 18px;
      font-weight: 700;
    }

    .el-row {
      margin-bottom: 20px;
    }
  }

  .logo {
    min-width: 1200px;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 90;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 3px;
    display: flex;

    .index_login {
      margin: 0 auto;
      background-color: #f7f7f7;
      height: 40px;

      .index_login_box {
        min-width: 1200px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        margin: 0 auto;
        /*#dowebok{*/
        /*  animate-duration: 10s;    //动画持续时间*/
        /*  animate-delay: 1s;    //动画延迟时间*/
        /*  animate-iteration-count: 2;    //动画执行次数*/
        /*}*/
        .login_name {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: #666;
          font-size: 12px;

          .personal {
            padding: 0 20px;
            cursor: pointer;

            &:hover {
              color: orangered;
            }
          }

          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
            border-radius: 50%;
            overflow: hidden;
          }

          .no_login {
            font-size: 12px;
            color: #227ff1;
            cursor: pointer;
          }
        }
      }
    }

    .index_logo {
      min-width: 1200px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;

      .logo_left {
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        img {
          height: 45px;
        }

        .name {
          font-size: 32px;
          font-weight: 700;
          margin-left: 20px;
        }
      }

      .logo_right {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #333;
        font-size: 16px;
        line-height: 24px;
        margin-left: 30px;

        .name {
          margin-left: 30px;
          cursor: pointer;
          position: relative;

          &:hover {
            color: #f9563a;
          }
        }

        .name.active {
          color: #f9563a;
        }

        .name.active:before {
          position: absolute;
          content: "";
          left: 0;
          right: 0;
          bottom: -5px;
          width: 50px;
          height: 3px;
          margin: 0 auto;
          border-radius: 10px;
          background-color: #f9563a;
        }

        .learning {
          margin-left: 30px;
          cursor: pointer;
          position: relative;

          &:hover {
            color: #f9563a;
          }

          .learning_wx {
            position: absolute;
            top: 40px;
            right: 0;
            width: 180px;
            background-color: #fff;
            z-index: 100;
            border-radius: 10px;
            border: 1px solid #eee;
            margin: 0 auto;
            text-align: center;
            color: #333;
            padding: 10px;
            font-size: 13px;

            img {
              padding: 5px 0;
              width: 150px;
              height: 150px;
            }
          }
        }

        .logo_right_dl {
          margin-left: 20px;

          .login_name {
            height: 80px;
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #333;
            font-size: 16px;
            position: relative;

            .personal {
              padding: 0 20px;
              cursor: pointer;

              &:hover {
                color: orangered;
              }
            }

            .personal_hy {
              font-size: 12px;

              &:hover {
                color: orangered;
              }
            }

            .personal_out {
              color: #0c85e3;
              font-size: 12px;
              margin-left: 5px;
              cursor: pointer;
            }

            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
              border-radius: 50%;
              overflow: hidden;
            }

            .no_login {
              color: #227ff1;
              cursor: pointer;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
</style>
